import CardProfile from 'components/CardProfile';
import React, { useCallback } from 'react'
import cx from "classnames";
// import { userContext } from 'Context/userContext';
import SkeletonCardProfile from 'skeletons/SkeletonCardProfile';
import { getProfile } from 'services/apiRoutes';
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';


export default function Sambutan() {
  // const { profile } = useContext(userContext);
  const {slug}=useParams()
  const [profile,setProfile]=useState()

    const profileAPI = useCallback(async () => {
      const res = await getProfile(slug);
      if (res.error) {
        return res.message;
      } else {
        const { data } = res.data;
        setProfile(data);
      }
    }, [slug]);

    useEffect(() => {
      profileAPI();
    }, [profileAPI]);

  const elipseClasses = cx({
    'absolute  rounded-full shadow -z-[1] top-1/3  w-[130px] h-[130px] ': true,
  });
  return (
    <div className="px-5 space-y-16 bg-white wrapper xl:px-99">
      <h1 className="text-3xl font-bold mt-36">Sambutan Kepala Desa</h1>
      <div className="w-full space-y-5 xl:space-y-0 inner xl:flex xl:space-x-5">
        {profile ? (
          <CardProfile
            nama={profile?.KepalaDesa?.nama}
            jabatan={profile?.KepalaDesa?.jabatan_obj?.nama}
            hp={profile?.KepalaDesa?.telepon}
            email={profile?.KepalaDesa?.email}
            profileImage={profile?.KepalaDesa?.url_gambar}
          />
        ) : (
          <SkeletonCardProfile />
        )}

        <div className="px-16 relative py-32 bg-transparent z-0 border xl:w-[70%] sambutanWrapper rounded-2xl border-borderCardFeatures">
          <div className={`left-0 orangeElipse ml-14 ${elipseClasses}`} />
          <div className={`right-0 greenElipse mr-14 ${elipseClasses}`} />
          <span className="block text-xs font-medium md:text-base mb-9">
            Assalamu’alaikum warahmatullahi wabarakatuh
          </span>
          <p className="text-justify md:text-base ">
            {profile?.ProfilDesa?.sambutan}
          </p>
          <span className="block text-xs font-medium md:text-base mt-9">
            Teurimong Geunaseh.
          </span>
        </div>
      </div>
    </div>
  );
}
